import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="max-w-shell mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="FAQ"
            title="常见问题"
            desc="关于信息来源、时间线标注与线索投递，这里回答得最集中的几个问题。"
          />
        </div>
        <div className="lg:col-span-8 flex flex-col gap-3">
          {faqs.map((item, index) => {
            const active = open === index;
            return (
              <div
                key={item.question}
                className={`rounded-lg border transition-colors ${
                  active ? "bg-background-50 border-primary-200" : "bg-background-50 border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(active ? -1 : index)}
                  aria-expanded={active}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950">
                    {item.question}
                  </h3>
                  <span
                    className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors ${
                      active ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={active ? "ri-subtract-line" : "ri-add-line"} />
                  </span>
                </button>
                {active ? (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}